export default __webpack_public_path__ + "static/media/facebook.56e078e9.svg";